import { rpc } from './client';
import type { Team, TeamMember } from '../types/team';

export const teamsApi = {
  createTeam: (name: string) => {
    const id = crypto.randomUUID();
    return rpc<Team>('CreateTeam', { id, name });
  },
  listMyTeams: () => rpc<Team[]>('ListMyTeams', {}),
  listTeamMembers: (teamId: string, query: string, page: number, pageSize: number) =>
    rpc<{ members: TeamMember[]; totalCount: number; page: number; pageSize: number }>(
      'ListTeamMembers', { teamId, query, page, pageSize }
    ),
  getTeam: (teamId: string) => rpc<Team & { members: TeamMember[] }>('GetTeam', { teamId }),
  updateTeam: (teamId: string, name: string) => rpc<void>('UpdateTeam', { teamId, name }),
  addTeamMember: (teamId: string, userId: string, role: string) => rpc<void>('AddTeamMember', { teamId, userId, role }),
  removeTeamMember: (teamId: string, userId: string) => rpc<void>('RemoveTeamMember', { teamId, userId }),
  updateTeamMemberRole: (teamId: string, userId: string, role: string) => rpc<void>('UpdateTeamMemberRole', { teamId, userId, role }),
  leaveTeam: (teamId: string) => rpc<void>('LeaveTeam', { teamId }),
};
